import Modal from "react-bootstrap/Modal";
import React from "react";
import { MdClose } from "react-icons/md";
import { trackEvent } from "../../utils/mixpanel";
import { Button } from "react-bootstrap";
const ConfirmationModal = ({
  show,
  handleCloseModal,
  handleConfirmDelete,
  fromContact = false,
  deleteAccountMessage,
  confirmTitle = "record",
  deleteAll,
  setIsCheckAll,
  removeMember,
  isRemoveMemberMessage,
}) => {
  const handleChange = (e) => {
    const value = e.currentTarget.checked;
    setIsCheckAll(value);
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleCloseModal}
        aria-labelledby="contained-modal-title-vcenter"
        className="customModal square-modal"
        size="sm"
      >
        <Modal.Header>
          <div className="modalGradientCircle"></div>
          <MdClose onClick={handleCloseModal} className="modalCloseBtn" />
        </Modal.Header>

        <Modal.Body
          style={{ padding: "0" }}
          className="d-flex flex-column align-items-center justify-content-center text-center px-4 py-4"
        >
          <div className="mb-3" style={{ maxWidth: "500px" }}>
            <h5 className="fw-bold mb-3">Are you sure?</h5>

            <p style={{ lineHeight: "1.6" }}>
              {confirmTitle === "nfc" ? (
                <>
                  NFC tag and associated function will be removed from your
                  account. Are you sure you want to unlink your bracelet?
                </>
              ) : isRemoveMemberMessage ? (
                <>
                  Are you sure you want to remove this member from your team?
                  <br />
                  Their team subscription along with data created by them will
                  be lost permanently.
                </>
              ) : (
                <>
                  {deleteAccountMessage ? deleteAccountMessage : ""}
                  {deleteAccountMessage
                    ? " Are you sure you want to"
                    : `Are you sure you want to`}{" "}
                  <br />
                  {removeMember ? "remove" : "delete"}{" "}
                  {deleteAccountMessage ? "your" : "this"} {confirmTitle}?
                </>
              )}
            </p>
          </div>

          {deleteAll && (
            <div
              className="form-check d-flex align-items-start gap-2 mb-3"
              style={{ maxWidth: "500px" }}
            >
              <input
                className="form-check-input mt-1"
                type="checkbox"
                id="flexCheckDeleteAll"
                onChange={(e) => handleChange(e)}
              />
              <label
                className="form-check-label text-start text-muted"
                htmlFor="flexCheckDeleteAll"
                style={{ fontSize: "14px", lineHeight: "1.5" }}
              >
                I agree to delete all cards associated with this card. Also,
                members in that hierarchy will be unassigned.
              </label>
            </div>
          )}

          <div className="d-flex justify-content-center mt-2 mobileViewWrapper">
            <Button
              variant="danger"
              onClick={() => {
                trackEvent(
                  removeMember ? "Team Member Removed" : "Item Deleted",
                  {
                    confirmTitle: confirmTitle,
                    deleteAllChecked: deleteAll || false,
                    removeMember: removeMember,
                    timestamp: new Date().toISOString(),
                  }
                );

                handleConfirmDelete();
              }}
            >
              {removeMember ? "Remove" : "Delete"}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default ConfirmationModal;
